import { useEffect, useState } from "react";

export default function useImageUpload(savedUrl) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [removed, setRemoved] = useState(false);

  useEffect(() => () => {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
  }, [previewUrl]);

  const upload = (next) => {
    setFile(next);
    setPreviewUrl(URL.createObjectURL(next));
    setRemoved(false);
  };

  const remove = () => {
    setFile(null);
    setPreviewUrl(null);
    setRemoved(true);
  };

  const restore = () => setRemoved(false);

  let payload = {};
  if (file) payload = { main_image: file };
  else if (removed) payload = { remove_main_image: true };

  return {
    imageUrl: previewUrl || (removed ? null : savedUrl || null),
    fileName: file ? file.name : null,
    changed: !!file || removed,
    upload,
    remove,
    restore,
    payload,
  };
}
